module.exports = __webpack_public_path__ + "img/gpnlogo3.46863760.png";